<template>
    <div class="flex items-center">
        <base-button-icon
            @click="openHelp"
            icon-name="help"
            :button-text="$t('HELP')"
            :hide-text="isWordyLocale"
        />

        <base-modal
            @modalClose="showModal = false"
            :show-modal="showModal"
            padding-size="large"
            :show-border="true"
        >
            <template v-slot:header>
                <h1 class="mt-4 uppercase text-xl font-bold">
                    {{ $t('NEED_HELP') }}
                </h1>

                <p class="text-lg">
                    {{ $t('CUSTOMER_SERVICE') }}
                </p>
            </template>

            <template v-slot:content>
                <h2 class="uppercase text-xl font-bold">
                    {{ $t('CALL_US') }}
                </h2>

                <div class="text-lg">
                    <a :href="`tel:${$t('PHONE_NUMBER')}`">
                        {{ $t('PHONE_NUMBER_FORMATTED') }}
                    </a>

                    <p class="whitespace-pre-line">
                        {{ $t('HOURS') }}
                    </p>

                    <a
                        :href="`${baseUrl}/contact`"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-rust"
                    >
                        {{ $t('MESSAGE_US') }}
                    </a>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import BaseButtonIcon from './BaseButtonIcon.vue';
    import BaseModal from './BaseModal.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseButtonIcon,
            BaseModal,
        },

        data() {
            return {
                showModal: false,
            };
        },

        computed: {
            locale() {
                return this.customizerStore.options?.locale;
            },

            baseUrl() {
                return this.customizerStore.buildBaseUrl();
            },

            isWordyLocale() {
                return this.customizerStore.isWordyLocale;
            },
        },

        methods: {
            openHelp() {
                this.showModal = true;
            },
        },
    };
</script>
